import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, UrlPipe } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { StorageService } from 'src/app/service/storage/storage.service';
import {
  TCPayload,
  TermsAndConditionsService,
} from 'src/app/service/terms-and-conditions/terms-and-conditions.service';

@Component({
  selector: 'app-tc-acceptance',
  templateUrl: './tc-acceptance.component.html',
  styleUrls: ['./tc-acceptance.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatCheckbox, RouterLink, AsyncPipe, TranslatePipe, UrlPipe],
})
export class TcAcceptanceComponent implements OnInit {
  data$: Observable<any> = this.component.data$;
  termsVersion: TCPayload = {
    tncVersionNo: '',
  };
  version$: Observable<any>;
  isDisabled = true;
  show = false;
  constructor(
    public component: CmsComponentData<any>,
    private tcService: TermsAndConditionsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService
  ) {
    tcService.tncVersion.subscribe((data) => {
      this.termsVersion.tncVersionNo = data;
    });
  }

  ngOnInit() {
    this.data$.subscribe((data) => data);
    this.isDisabled = true;
    if (this.storageService.getLocalStorageItem('showTCAccept') === 'true') {
      this.show = true;
      this.cdr.detectChanges();
    }
  }

  onChecked(event: any) {
    if (event.checked) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  acceptTerms() {
    this.tcService
      .updateTC(this.termsVersion)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.storageService.removeLocalStorageItem('showTCAccept');
          this.router.navigate(['/']);
        },
        (err) => {
          this.errorHandlr(err);
        }
        // () => { this.cdr.detectChanges(); }
      );
  }

  errorHandlr(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
